import { createContext, useState } from "react";
// import TeethChart from "./components/TeethChart";
import { FormProvider, useForm } from "react-hook-form";
import { Tooth } from "./components/DentalForm/components/Types";
import TeethChart from "./v2/TeethChart";
import DentalTabs from "./v2/DentalForm/components/Tabs";
export type TeethSectionType = {
  l1: boolean;
  l2: boolean;
  r1: boolean;
  r2: boolean;
  c: boolean;
};
export type TeethContextType = {
  selectedTooth: { [key: string]: Tooth }; // Object where key is a string (e.g. "teeth18") and value is a Teeth object
  setSelectedTooth: React.Dispatch<React.SetStateAction<{ [key: string]: Tooth }>>;
  edit: any,
  setEdit: React.Dispatch<React.SetStateAction<any>>;
  saveFlag: boolean
  setSaveFlag: React.Dispatch<React.SetStateAction<any>>;
};
const defaultContextValue: TeethContextType = {
  selectedTooth: {},
  setSelectedTooth: () => { },
  edit: {},
  setEdit: () => { },
  saveFlag: false,
  setSaveFlag: () => { }
};
export const TeethContextv2 = createContext<TeethContextType>(defaultContextValue);
const DentalProcedureV2 = () => {
  const [selectedTooth, setSelectedTooth] = useState({})
  const [saveFlag, setSaveFlag] = useState<boolean>(false)
  const [edit, setEdit] = useState({})
  const method = useForm()
  return (
    <TeethContextv2.Provider value={{ selectedTooth, setSelectedTooth, edit, setEdit, saveFlag, setSaveFlag }}>
      <FormProvider {...method}>
        <TeethChart />
        <div className="p-2">

          <DentalTabs />
        </div>
      </FormProvider>
    </TeethContextv2.Provider>
  );
};
export default DentalProcedureV2;
